import { Box, CheckBox, ColorOptions, Text } from '@jfs/ui-new'
import { TextInputNew } from '../AdminInputs'
import { useCallback } from 'react'
import { camelCaseToTitleCase, parseDateWithTime } from '../../utils'
import { tableItemStrings } from '../../utils/constants'
import { DropdownOptimised } from '../DropdownNew'
import { DropdownTypes } from '../DropdownNew/types'
import { ExpandableTextView } from '../ExpandableTextView'
import { Retry } from './NewTableItem/Retry'
import { getActionView } from './NewTableItem/getActionView'
import { CopyView } from './NewTableItem/getCopyView'
import { ActionType } from './NewTableItem/types'
import { TableDatePickerReact } from './TableDatePicker'
const CustomCellRenderer = ({
  cellData,
  rowIndex,
  styles,
  onCheckChange,
  isRowChecked,
  tableRef,
  data,
  onAction,
  onDownloadFileAction,
  dataKey,
  rowData,
  onRowClick,
  isStatusClickable,
  onStatusPress,
  onRowEditClicked,
  onChangeInput,
  onRetry,
  enableCheckBox,
  commentsData,
  showDefaultExpandedCommentView,
}: any) => {
  const handleRowCheckChange = () => {
    if (tableRef) {
      tableRef.current.forceUpdateGrid()
    }
    if (onCheckChange) {
      onCheckChange(!rowData?.isSelected, rowIndex, rowData) //onCheckChange(!isRowChecked, rowIndex)
    }
  }
  const bgStyle =
    `${cellData}`?.toLowerCase() === 'pending for approval'
      ? styles.pendingForApproval
      : dataKey !== 'makerComments' && dataKey !== 'comments'
      ? styles[`${cellData}`?.toLowerCase()] ?? styles.defaultCell
      : styles.defaultCell
  // console.log('cellData, bgStyle: ', cellData, bgStyle, `${cellData}`?.toLowerCase())
  const textStyles = cellData === '0' ? styles.titleHeader : styles.title

  const handleOnChange = (data: string | number[]): void => {
    console.log('handleOnChange', data)
  }

  const handleDownload = (fileType: string) => {
    if (onDownloadFileAction) {
      onDownloadFileAction(fileType, rowIndex)
    }
  }

  const handleCellPress = () => {
    if (isStatusClickable && onStatusPress && dataKey === 'status') {
      onStatusPress(rowData)
    } else {
      onRowClick && rowData && onRowClick(rowData)
    }
  }

  const defaultView = (isEmptyAllowed: boolean = false) => {
    const actualValue = typeof cellData === 'string' ? cellData?.trim() : cellData
    const placeHolder = isEmptyAllowed ? '' : 'N/A'
    const text = typeof actualValue === 'function' ? actualValue(cellData) : !actualValue ? placeHolder : actualValue
    return (
      <Box {...bgStyle} justifyContent="center" f={1} testID={actualValue} onPress={handleCellPress}>
        <ExpandableTextView
          text={text}
          // eslint-disable-next-line react-native/no-inline-styles
          textStyle={{
            ...(tableItemStrings.link.includes(dataKey) ? styles.linkStyle : textStyles),
            color: tableItemStrings.link.includes(dataKey)
              ? 'BLUE'
              : dataKey !== 'makerComments' && dataKey !== 'comments'
              ? styles[`${cellData}`?.toLowerCase()]?.color
              : 'BLACK_21',
          }}
          rowData={rowData}
          commentsData={[{ key: dataKey, heading: camelCaseToTitleCase(dataKey) }]}
          modelTitle={'Data'}
          dialogStyle={{ width: '30vw', height: '30vh', backgroundColor: 'BACKGROUND_LIGHT' }}
        />
        {/*<Text
         commentsData={[
            { key: 'entityId', heading: 'Entity Id' },
            //{ key: 'entityName', heading: 'Entity Name' },
            { key: 'originalTransactionId', heading: 'Transaction Id' },
            { key: 'settlementNetAmount', heading: 'Settlement NetAmount' },
            { key: 'type', heading: 'Type' },
            { key: 'createdBy', heading: 'Created By' },
            { key: 'createdAt', heading: 'Created At' },
            { key: 'comments', heading: 'Comments' },
          ]}
          numberOfLines={1}
          {...(tableItemStrings.link.includes(dataKey) ? styles.linkStyle : textStyles)}
          color={
            tableItemStrings.link.includes(dataKey)
              ? 'BLUE'
              : dataKey !== 'makerComments' && dataKey !== 'comments'
              ? styles[`${cellData}`?.toLowerCase()]?.color
              : 'BLACK_21'
          }>
          {typeof actualValue === 'function' && actualValue(cellData)}
          {typeof cellData !== 'function' &&
            `${actualValue === undefined || actualValue === '' ? placeHolder : actualValue}`}
        </Text>*/}
      </Box>
    )
  }

  const executeAction = (actionType: ActionType) => {
    if (onAction) {
      onAction(actionType, data[rowIndex].id, rowData)
    }
  }

  const handlEditRowChange = useCallback(() => {
    if (tableRef) {
      tableRef.current.forceUpdateGrid()
    }
    if (onRowEditClicked) {
      onRowEditClicked(!rowData?.editable, rowIndex, rowData)
    }
  }, [data])
  const onChangeText = useCallback(
    (text) => {
      text = text.replace(/[^0-9.]/g, '')
      onChangeInput({ index: rowIndex, id: rowData?.id, dataKey, value: text, data })
    },
    [data],
  )

  const getEditableTextView = () => {
    const isEditable = rowData?.editable
    const actualValue = typeof cellData === 'string' ? cellData?.trim() : cellData
    return (
      <Box marginVertical={5}>
        {isEditable ? (
          <TextInputNew
            borderColor={'#d1d3e2' as ColorOptions}
            onFocusBorderWidth={1}
            paddingHorizontal={8}
            minHeight={35}
            type="body12"
            color={'BLACK_21' as ColorOptions}
            fontSize={12}
            onChangeText={onChangeText}
            value={actualValue}
            borderRadius={8}
          />
        ) : (
          <Text {...textStyles} numberOfLines={1}>
            {actualValue}
          </Text>
        )}
      </Box>
    )
  }
  const onDateChanged = useCallback(
    (fieldName, value) => {
      onChangeInput({ index: rowIndex, id: rowData?.id, dataKey: fieldName, value: value, data })
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [data],
  )
  const renderDatePicker = () => {
    const isEditable = rowData?.editable
    const date = cellData
    let today: any = new Date()
    let nextThreeMonth = new Date(new Date().setMonth(today.getMonth() + 3))
    return (
      <Box>
        {isEditable ? (
          <TableDatePickerReact
            minDate={today}
            showTimeInput
            maxDate={nextThreeMonth}
            dateValue={date}
            dateFormat={'dd-MM-yyyy HH:mm'}
            onDateChanged={onDateChanged}
            fieldName={dataKey}
          />
        ) : (
          <Text {...textStyles} numberOfLines={1}>
            {parseDateWithTime(date)}
          </Text>
        )}
      </Box>
    )
  }

  const getDownloadOptions = () => {}
  return dataKey === 'check' ? (
    <CheckBox
      onChange={handleRowCheckChange}
      checked={rowData?.isSelected} //isRowChecked
      iconSize={24}
      color={
        ((rowData?.applicationStatus?.toLowerCase() === 'pending' ||
          rowData?.applicationStatus?.toLowerCase() === 'pending for approval') &&
          rowData?.assignee?.toLowerCase() === 'na') ||
        (rowData?.actionDownload === 'Download' && rowData?.postReconDate?.length > 0) ||
        enableCheckBox
          ? 'PRIMARY'
          : 'DARK_GREY'
      }
      disabled={
        !(
          ((rowData?.applicationStatus?.toLowerCase() === 'pending' ||
            rowData?.applicationStatus?.toLowerCase() === 'pending for approval') &&
            rowData?.assignee?.toLowerCase() === 'na') ||
          (rowData?.actionDownload === 'Download' && rowData?.postReconDate?.length > 0) ||
          enableCheckBox
        )
      }
    />
  ) : cellData === 'EXPORT' ? (
    <DropdownOptimised
      disabled={false}
      placeHolder={'Download'}
      buttonLabel="Download Now"
      data={getDownloadOptions()}
      onChange={handleOnChange}
      onButtonPress={handleDownload}
      type={DropdownTypes.RADIO_BUTTON}
      testID={`downloadInListItem${rowIndex}`}
    />
  ) : dataKey === 'url' ? (
    <CopyView itemData={data[rowIndex]} entry={cellData} statusStyle={bgStyle} textStyles={textStyles} />
  ) : dataKey === 'actionDownload' || dataKey === 'actionHoldRelease' ? (
    getActionView(cellData, executeAction, dataKey, rowIndex)
  ) : dataKey === 'editable' ? (
    <CheckBox
      checked={rowData?.editable}
      iconSize={24}
      onChange={handlEditRowChange}
      disabled={data.some((item) => item?.editable) && !rowData?.editable}
    />
  ) : dataKey === 'failureRate' || dataKey === 'resetAfter' ? (
    getEditableTextView()
  ) : dataKey === 'plannedDowntimeStartAt' || dataKey === 'plannedDowntimeEndAt' ? (
    renderDatePicker()
  ) : dataKey === 'action' && cellData === '_retry' ? (
    <Retry onPress={onRetry} item={rowData} />
  ) : dataKey === 'comments' ? (
    <ExpandableTextView
      text={cellData}
      rowData={rowData}
      commentsData={commentsData}
      showDefaultExpandedView={showDefaultExpandedCommentView}
    />
  ) : (
    defaultView(false)
  )
}

export { CustomCellRenderer }
